import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { OptionsAutocomplete } from 'src/app/core/interfaces/optionsAutocomplete';
import { Permission } from 'src/app/core/resources/permission';
import { Utils } from 'src/app/core/resources/utils';
import { MenuServiceService } from '../../menu-service/menu-service.service';
import { Router } from '@angular/router';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { PermissionRole } from 'src/app/core/resources/permission-role';
import { Patterns } from 'src/app/core/resources/patterns';
import { CatalogItem } from 'src/app/core/interfaces/catalogItem';
import { Global } from 'src/app/core/resources/global';
import { Fmt } from 'src/app/core/messages/fmt';
import { ServiceResources } from '../../resources/services';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Cargo } from 'src/app/core/interfaces/cargo';
@Component({
  selector: 'app-escorted-vehicle-form',
  templateUrl: './escorted-vehicle-form.component.html',
  styleUrls: ['./escorted-vehicle-form.component.scss']
})
export class EscortedVehicleFormComponent implements OnInit {

  permission = Permission;
  // Vehicle Controls
  licensePlateControl: FormControl = new FormControl('', Validators.required);
  containerNumberControl: FormControl = new FormControl('', Validators.pattern(this.patterns.CONTAINER_FORMAT_FULL.source));
  brandControl: FormControl = new FormControl('');
  colorControl: FormControl = new FormControl('');
  documentTypeDriverControl: FormControl = new FormControl('');
  documentDriverControl: FormControl = new FormControl('');
  nameDriverControl: FormControl = new FormControl('');
  phoneNumberDriverControl: FormControl = new FormControl('', [Validators.maxLength(10)]);
  vehicleTypeControl: FormControl = new FormControl('');
  optionsTypeVehicle: OptionsAutocomplete = {
    showAutocomplete: true,
    title: 'Tipo de vehiculo',
    appearance: 'outline',
  };

  formValidate = '';
  formSubscription: Subscription;
  documentTypes: CatalogItem[] = this.utils.clone(this.global.documenTypes);
  isDialog: boolean = false;


  constructor(
    @Inject(MAT_DIALOG_DATA)
    public paramsDialog: { cargo: Cargo },
    public dialogRef: MatDialogRef<EscortedVehicleFormComponent>,
    public utils: Utils,
    public menuService: MenuServiceService,
    private router: Router,
    private serviceResources: ServiceResources,
    private snackBarService: SnackBarService,
    private permissionRole: PermissionRole,
    private patterns: Patterns,
    private global: Global
  ) { }

  ngOnInit() {
    this.documentTypes.splice(2, 1);
    this.checkDialogParams();
    this.setLocalValues();
    this.setSubscription();
    this.checkPermissionsToEdit();
  }

  private checkDialogParams() {
    if (this.paramsDialog && this.paramsDialog.cargo) {
      this.isDialog = true;
      this.menuService.cargo = this.paramsDialog.cargo;
      this.menuService.patchForm(this.paramsDialog.cargo, false);
    }
  }

  private setLocalValues() {
    this.licensePlateControl.setValue(this.menuService.form.get('escortedVehicle.licensePlate').value);
    this.containerNumberControl.setValue(this.menuService.form.get('escortedVehicle.container').value);
    this.brandControl.setValue(this.menuService.form.get('escortedVehicle.brand').value);
    this.colorControl.setValue(this.menuService.form.get('escortedVehicle.color').value)
    const documentTypeId = this.menuService.form.get('escortedVehicle.driver.documentTypeId').value;
    const documentType = this.documentTypes.find(documentType => documentType.id === documentTypeId);
    this.documentTypeDriverControl.setValue(documentType || null);
    this.documentDriverControl.setValue(this.menuService.form.get('escortedVehicle.driver.document').value);
    this.nameDriverControl.setValue(this.menuService.form.get('escortedVehicle.driver.name').value);
    this.phoneNumberDriverControl.setValue(this.menuService.form.get('escortedVehicle.driver.phoneNumber').value);
    const vehicleType = this.menuService.form.get('escortedVehicle.vehicleType').value;
    this.optionsTypeVehicle = { ...this.optionsTypeVehicle, initialValue: vehicleType ? vehicleType : '' };
    this.vehicleTypeControl.setValue({ name: vehicleType ? vehicleType : '' });
  }

  private setSubscription() {
    this.formSubscription = this.menuService.formObservable.subscribe(() => this.setLocalValues());
  }

  private checkPermissionsToEdit() {
    if (!this.canEditEscortedVehicle) {
      this.formValidate = 'disable';
      this.vehicleTypeControl.disable();
      this.licensePlateControl.disable();
      this.containerNumberControl.disable();
      this.brandControl.disable();
      this.colorControl.disable();
      this.documentTypeDriverControl.disable();
      this.documentDriverControl.disable();
      this.nameDriverControl.disable();
      this.phoneNumberDriverControl.disable();
    }
  }

  get canViewEscortedVehicle(): boolean {
    return this.permissionRole.hasPermission(
      this.permission.cargo.module,
      this.permission.cargo.showEscortInfoModule
    );
  }
  get canEditEscortedVehicle(): boolean {
    return this.permissionRole.hasPermission(
      this.permission.cargo.module,
      this.permission.cargo.editCargo
    ) && this.canViewEscortedVehicle;
  }

  get enableOnlyNumbers(): boolean {
    return this.documentTypeDriverControl.value && this.documentTypeDriverControl.value.id === '1';
  }

  backToPreviousStep() {
    if (this.menuService.isSatelliteLockService())
      return this.router.navigate([Fmt.string(this.serviceResources.serviceRequestUrls.destination, this.menuService.cargo.consecutive)]);
    this.router.navigate([Fmt.string(this.serviceResources.serviceRequestUrls.vehicle, this.menuService.cargo.consecutive)]);
  }

  private isValidForm(): boolean {
    if (this.utils.errorMessagesCustomized(this.licensePlateControl, 'placa del vehiculo')) return false;
    if (this.utils.errorMessagesCustomized(this.containerNumberControl, 'numero de contenedor')) return false;
    if (this.utils.errorMessagesCustomized(this.phoneNumberDriverControl, 'celular del conductor', null, 10)) return false;
    return true;
  }

  saveAndContinue() {
    if (this.isDialog && !this.isValidForm()) return;
    const vehicleType = this.vehicleTypeControl.value && this.vehicleTypeControl.value.name ? this.vehicleTypeControl.value.name : '';
    this.menuService.form.get('escortedVehicle.licensePlate').setValue(this.licensePlateControl.value);
    this.menuService.form.get('escortedVehicle.container').setValue(this.containerNumberControl.value);
    this.menuService.form.get('escortedVehicle.vehicleType').setValue(vehicleType);
    this.menuService.form.get('escortedVehicle.brand').setValue(this.brandControl.value);
    this.menuService.form.get('escortedVehicle.color').setValue(this.colorControl.value);
    this.menuService.form.get('escortedVehicle.driver.documentTypeId').setValue(
      this.documentTypeDriverControl.value ? this.documentTypeDriverControl.value.id : null);
    this.menuService.form.get('escortedVehicle.driver.documentTypeName').setValue(
      this.documentTypeDriverControl.value ? this.documentTypeDriverControl.value.name : null);
    this.menuService.form.get('escortedVehicle.driver.document').setValue(this.documentDriverControl.value);
    this.menuService.form.get('escortedVehicle.driver.name').setValue(this.nameDriverControl.value);
    this.menuService.form.get('escortedVehicle.driver.phoneNumber').setValue(this.phoneNumberDriverControl.value);
    this.menuService.updateService().then(() => {
      this.snackBarService.openSnackBar('Servicio actualizado exitosamente');
      if (!this.isDialog) this.continueToNextStep();
      else this.dialogRef.close({ state: true });
    }).catch(() => this.snackBarService.openSnackBar('Ocurrió un error al actualizar el servicio', undefined, 'error'));
  }

  continueToNextStep() {
    this.router.navigate([Fmt.string(this.serviceResources.serviceRequestUrls.loadCharacteristics, this.menuService.cargo.consecutive)]);
  }

  compareDocumentTypes(docType1: CatalogItem, docType2: CatalogItem): boolean {
    if (!docType1 || !docType2) return docType1 === docType2;
    return docType1.id === docType2.id;
  }

  ngOnDestroy() {
    if (this.formSubscription) this.formSubscription.unsubscribe();
  }

}
